<script lang="ts">
  import { GoogleOAuthProvider } from "google-oauth-gsi";
  import { addUser, getUser } from "./firebaseOperations";
  import { userSignedIn, userData } from "./store";

  const client_id = process.env.GOOGLE_CLIENT_ID;

  type UserData = {
  id: string;
  admin: boolean;
  premium: boolean;
  creation: Date;
  lastlogin: Date;
  credits: number;
  email: string;
  name: string;
  identityVerified: boolean;
};

  async function handleAddUser(userData: UserData) {
    addUser(userData);
    // console.log("User added to database" + userData)
  }
  export const provider = new GoogleOAuthProvider({
    clientId: client_id,
    onScriptLoadError: () => console.log("Google script failed to load"),
    onScriptLoadSuccess: () => {
      // Check if user is already logged in on page load
      const token = localStorage.getItem("googleToken");
      if (token) {
        fetchData(token)
          // .then((data) => {
          //   // actualUser = await getUser(data.sub);
          //   // userData.set(data);
          //   // console.log($userData)
          //   // if($userData.id){
          //   //   userSignedIn.set(true);
          //   // }
          // })
          // .catch((error) => {
          //   console.error("Error fetching user data:", error);
          // });
      }
    },
  });
  async function BackendSignIn(data) {
    const result = await getUser(data.sub);
    // console.log("get user:" + result);
    if (result == 0) {
      const newData = {
        id: data.sub,
        admin: false,
        premium: false,
        creation: new Date(),
        lastlogin: new Date(),
        credits: 3,
        email: data.email,
        name: data.name,
        identityVerified: false,
      };
      await handleAddUser(newData);
    }
    const userInfo = await getUser(data.sub);
    // query backend database
    // Update userData object with user data
    const today = new Date();
    $userData = {
      id: userInfo.id,
      admin: userInfo.admin,
      premium: userInfo.premium,
      creation: userInfo.creation,
      lastLogin: today,
      credits: userInfo.credits, 
      email: userInfo.email,
      name: userInfo.name
    };
    // console.log($userData)
    // if($userData.id){
      userSignedIn.set(true);
      // reload page
      // window.location.reload();
    // }

    // document.getElementById("signIn").style.display = "none";

    return $userData;
  }
  const loginWithToken = provider.useGoogleLogin({
    flow: "implicit",
    onSuccess: async (tokenResponse) => {
      localStorage.setItem("googleToken", tokenResponse.access_token);
      const data = await fetchData(tokenResponse.access_token);
      // console.log(data)
      await BackendSignIn(data); // Await this call to ensure it completes before the next line
      window.location.reload();

    },
  });
  async function fetchData(accessToken: any) {
    const endpoint = "https://www.googleapis.com/oauth2/v3/userinfo";
    const response = await fetch(endpoint, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    if (!response.ok) {
      // console.error("Failed to fetch user info");
    }
    const data = await response.json();
    // Return the email from the response
    return data;
  }
</script>

<button on:click={() => loginWithToken()}>
  <img src="google.svg" alt="Google logo" class="google-logo" />
  Sign In with Google
</button>

<style>
  button {
    font-family: "Roboto", sans-serif;
    font-weight: 500;
    font-size: 14px;
    letter-spacing: 0.2px;
    line-height: 16px;
    padding: 10px 24px;
    border-radius: 4px;
    border: none;
    cursor: pointer;
    transition: background-color 0.3s;
    display: inline-block;
    box-shadow: 0 1px 2px rgba(60, 64, 67, 0.3),
      0 2px 6px 2px rgba(60, 64, 67, 0.15);
    transition: all 0.2s ease-in-out;
    outline: none;
  }
  button:hover {
    background-color: #fafafa;
  }
</style>
